import { types, actions } from './requests'
export const GETPACKAGE_TYPES = {
    ...types('GETPACKAGE'),
}
export const GETPACKAGE_ACTIONS = {
    ...actions('GETPACKAGE'),
}